import React, { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  requestPending,
  requestPristine /*requestSuccess, requestError*/,
} from "state/reducer/requestStatusSlice";
import { getCustomers } from "net/contracts";
import { useNavigate } from "react-router-dom";
import {
  EntityType,
  IAppUserProfile,
  RequestStatus,
  RoutePath,
} from "shared/constants";
import SimpleTable, {
  SimpleTableFamily,
  SimpleTableType,
} from "components/SimpleTable";
import TableRighArrow from "components/TableRightArrow";
import NoDataFound from "components/NoDataFound";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import useRequestStatus from "hooks/useRequestStatus";
import { DsTableDataParser } from "components/DSSimpleTable/dsTableDataParser";
import AddEntityButton from "components/AddEntityButton";
//import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";
import { Table, Input as TextInput } from "@ds/ds-snam/react";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements } from "shared/utils/dsComponentUtils";
import { de } from "date-fns/locale";

interface ICustomerElement {
  businessId: string;
  businessName: string;
  businessSecondName: string;
  businessVat: string;
  businessEmail: string; //new
  taxAgentFirstName: string; //new
  taxAgentSecondName: string; //new
  businessState: string; //new
}
const CustomerList: React.FC<{}> = (props) => {
    const { t } = useTranslation(["contract", "app"]);

    //const appUser: AppUser | undefined = useAppUser();
    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;

    const [customerList, setCustomerList] = useState<ICustomerElement[]>([]);
    const [customerListFiltered, setCustomerListFiltered] = useState<
        ICustomerElement[]
    >([]);
    const [filters, setFilters] = useState<{ [key: string]: string }>({
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
        col6: ""
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const requestStatus = useRequestStatus();

    const loadCustomers = useCallback(() => {
        dispatch(requestPending());
        getCustomers()
        .then((response: ICustomerElement[]) => {
            setCustomerList(response);
            setCustomerListFiltered(response);
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            dispatch(requestPristine());
        });
    }, [dispatch]);

    useEffect(() => {
        loadCustomers();
        return () => {
        dispatch(requestPristine());
        };
    }, [loadCustomers, dispatch]);

    const tableCols = (() => {
        //console.log( t("customer.customerList.tableColumns", {ns:'contract', returnObjects:true}) );
        //return ["Azienda", "Partita Iva", "Ragione Sociale"];
        //return t("customer.customerList.tableColumns", { ns: 'contract', returnObjects: true }) as string[];
        return [
        "Company",
        "Business name", //new
        "VAT number",
        //"Company name",
        "Contact Person",
        "Email",
        "Country",
        "",
        ];
    })();

    const tableRows = customerListFiltered.map((row: ICustomerElement, index) => {
        return (
        <tr key={uuidv4()} role="row">
            <td scope="row">{row.businessSecondName}</td>
            <td scope="row">{row.businessName}</td>
            <td scope="row">{row.businessVat}</td>
            <td scope="row">
            {row.taxAgentFirstName + " " + row.taxAgentSecondName}
            </td>
            <td scope="row">{row.businessEmail}</td>
            <td scope="row">{row.businessState}</td>
            <td scope="row">
            <TableRighArrow
                onClick={() => {
                navigate(row.businessId);
                }}
            />
            </td>
        </tr>
        );
    });

    const getCustomerListSearchColumns = (index: number) => {
        return (
        index === 0 ||
        index === 1 ||
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5
        );
    };

    
    // Gestione dei cambiamenti dei filtri
    const handleFilterChange = (columnKey: string, value: string) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };

    /**FILTER */
    useEffect(() => {
        let myFilteredList: ICustomerElement[] = [];
        for (let i in customerList) {
        if (
            customerList[i].businessSecondName.toLocaleLowerCase().includes(filters.col1.toLocaleLowerCase()) &&
            customerList[i].businessName.toLocaleLowerCase().includes(filters.col2.toLocaleLowerCase()) &&
            customerList[i].businessVat.toLocaleLowerCase().includes(filters.col3.toLocaleLowerCase()) &&
            (customerList[i].taxAgentFirstName.toLocaleLowerCase().includes(filters.col4.toLocaleLowerCase()) ||
            customerList[i].taxAgentSecondName.toLocaleLowerCase().includes(filters.col4.toLocaleLowerCase())) &&
            customerList[i].businessEmail.toLocaleLowerCase().includes(filters.col5.toLocaleLowerCase()) &&
            customerList[i].businessState.toLocaleLowerCase().includes(filters.col6.toLocaleLowerCase())
        ) {
            myFilteredList.push(customerList[i]);
        }
        }
        setCustomerListFiltered(myFilteredList);
    }, [
        filters
    ]);

    const getTableRowsCustomers = (): ITableRow[] => {
            let myRetArr: ITableRow[] = [];
            let test : ITableCell
            for (let i in customerListFiltered) {
                let tempObj: ITableRow = {
                    tableCells: [
                        { 
                            type: "text", 
                            text: customerListFiltered[i].businessSecondName,
                        },
                        { 
                            type: "text", 
                            text: customerListFiltered[i].businessName,
                        },
                        { 
                            type: "text", 
                            text: customerListFiltered[i].businessVat,
                        },
                        { 
                            type: "text", 
                            text: customerListFiltered[i].taxAgentFirstName + "" + customerListFiltered[i].taxAgentSecondName,
                        },
                        { 
                            type: "text", 
                            text: customerListFiltered[i].businessEmail,
                        },
                        { 
                            type: "text", 
                            text: customerListFiltered[i].businessState,
                        },
                    ],
                    rightIcon: "icon-chevron-right",
                };
                myRetArr.push(tempObj);
            }
            return myRetArr;
    };

    const myTableConfigCustomers: ITableConfig = {
            ...getDSTableSharedElements(560),
            tableHeader: {
                tableCellsHeader: [
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.0", {ns: "contract",}) as string,"col1","20%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col1"], //<---
                    },
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.1", {ns: "contract",}) as string,"col2","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col2"], //<---
                    },
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.2", {ns: "contract",}) as string,"col3","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col3"], //<---
                    },
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.3", {ns: "contract",}) as string,"col4","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col4"], //<---
                    },
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.4", {ns: "contract",}) as string,"col5","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col5"], //<---
                    },
                    {
                        ...getDSTableShaderElementsForFilterColumn(t("customer.customerList.colsLabels.5", {ns: "contract",}) as string,"col6","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                        searchBoxValue:filters["col6"], //<---
                    }
                ],
                hasSearchBox: true,
            },
            tableRows: getTableRowsCustomers(),
    };

    return (
        <>
        <p className="pageTitle" style={{ marginBottom: "10px" }}>
            {t("customer.customerList.title", { ns: "contract" })}
        </p>
        {/*<p className="pageSubTitle">
            {t("customer.customerList.subTitle", { ns: "contract" })}
        </p>*/}

        {(appUserProfile?.addEntityPolicy.includes(EntityType.BUSINESS) || appUserProfile?.addEntityPolicy.includes(EntityType.CUSTOMERDELEGATION))&& (
            <div
            style={{
                marginTop: "28px",
                marginBottom: "14px",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-end",
                gap:"15px"
            }}
            >
            {appUserProfile?.addEntityPolicy.includes(EntityType.BUSINESS) && <AddEntityButton entityType={EntityType.BUSINESS} />}
            {appUserProfile?.addEntityPolicy.includes(EntityType.CUSTOMERDELEGATION) && <AddEntityButton entityType={EntityType.CUSTOMERDELEGATION} />}
            </div>
        )}
        

        {customerList && customerList.length ? (
            <>
                {/*<div className="listTableContainer">
                    <SimpleTable
                        rows={tableRows}
                        columns={tableCols}
                        tableType={SimpleTableType.LIST}
                        simpleTableFamily={SimpleTableFamily.CUSTOMERLIST}
                        getSearchColumns={getCustomerListSearchColumns}
                        columnInputHandlers={[
                            (value) => handleFilterChange("col1", value),
                            (value) => handleFilterChange("col2", value),
                            (value) => handleFilterChange("col3", value),
                            (value) => handleFilterChange("col4", value),
                            (value) => handleFilterChange("col5", value),
                            (value) => handleFilterChange("col6", value),
                        ]} // Indica le funzioni per le colonne
                    />
                </div>*/}
                {
                    <Table 
                        tableConfig={myTableConfigCustomers} 
                        style={{}}
                        
                        onInputSearchBarChange={(event:Event)=>{
                            //console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                        }}
                        onResetSearch={(event:Event)=>{
                            //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                            switch ((event as CustomEvent).detail.cells) {
                                case 0:
                                    handleFilterChange("col1", "");
                                    break;
                                case 1:
                                    handleFilterChange("col2", "");
                                    break;
                                case 2:
                                    handleFilterChange("col3", "");
                                    break;
                                case 3:
                                    handleFilterChange("col4", "");
                                    break;
                                case 4:
                                    handleFilterChange("col5", "");
                                    break;
                                case 5:
                                    handleFilterChange("col6", "");
                                    break;
                                default:
                                    break;
                            }
                            /*handleFilterChangeAwaiting("col1","");
                            handleFilterChangeAwaiting("col2","");
                            handleFilterChangeCredited("col1","");
                            handleFilterChangeCredited("col2","");*/
                            //let cell = (event as CustomEvent).detail.cells;
                            //let focusCol = `col${cell}`.toString();
                            //const focusValue = "".toString();
                            //console.log(focusCol + " - " + focusValue)
                            //handleFilterChange(focusCol, focusValue)
                        }}
                        onSubmitSearchedText={(event:Event)=>{
                            const focusColtemp = (event as CustomEvent).detail.cells;
                            let focusCol = '';
                            switch (focusColtemp) {
                                case 0:
                                    focusCol = "col1";
                                    break;
                                case 1:
                                    focusCol = "col2";
                                    break;
                                case 2:
                                    focusCol = "col3";
                                    break;
                                case 3:
                                    focusCol = "col4";
                                    break;
                                case 4:
                                    focusCol = "col5";
                                    break;
                                case 5:
                                    focusCol = "col6";
                                    break;
                                default:
                                    break;
                            }
                            const focusValue = (event as CustomEvent).detail.searchedText;
                            handleFilterChange(focusCol, focusValue)
                        }}
                        //FILTERS
                        onClickRightAction={(event:Event)=>{
                            navigate(customerListFiltered[(event as CustomEvent).detail.row].businessId);
                        }}
                        onTableInputChange={(event:Event)=>{
                            const focusCol = (event as CustomEvent).detail.col;
                            const focusValue = (event as CustomEvent).detail.value;
                            //handleFilterChange(focusCol, focusValue)
                        }}
                        onColumnSorting={(event:Event)=>{
                            //console.log(event)
                        }}
                        onSearchBoxLeftButtonClick={(event:Event)=>{
                            //console.log('cliccato onSearchBoxLeftButtonClick')
                                    /**
                                     * 
                                handleFilterChangeAwaiting("col1","");
                                handleFilterChangeAwaiting("col2","");
                                handleFilterChangeCredited("col1","");
                                handleFilterChangeCredited("col2","");
                                    */
                        }}
                    />
                }
            </>
        ) : requestStatus === RequestStatus.SUCCESS ? (
            <NoDataFound
                title={t("customer.customerList.noData.title")} //"Non sono presenti clienti"
                subTitle={t("customer.customerList.noData.subTitle")}
            />
        ) : (
            <></>
        )}
        </>
    );
};

export default CustomerList;
